import React from "react";

const ASP_Application = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Application</h1>
      <p>This is the ASP Application page content.</p>
    </div>
  );
};

export default ASP_Application;
